import React from "react";
import { Sidebar } from "./layout/Sidebar";
import { Toaster } from "./ui/toaster";
import { useLocation } from "react-router-dom";
import AuthGuard from "./auth/AuthGuard";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  if (isLoginPage) {
    return (
      <>
        {children}
        <Toaster />
      </>
    );
  }

  return (
    <AuthGuard>
      <div className="min-h-screen bg-background">
        <div className="flex h-screen">
          <Sidebar />
          <main className="flex-1 overflow-y-auto p-6">
            {children}
          </main>
        </div>
        <Toaster />
      </div>
    </AuthGuard>
  );
};

export default Layout;